import {string} from 'prop-types';
import {Controller} from 'react-hook-form';

import {controlPropType, fieldPropType} from '../../../../proptypes-shapes';
import {buildFieldName} from '../buildFieldName';
import BrandedInputAdornment from '../field-components/BrandedInputAdornment/BrandedInputAdornment';
import FieldLabel from '../field-components/EmmaiFieldLabel/EmmaiFieldLabel';
import NumberField from '../field-components/NumberField/NumberField';

const NumberFieldRenderer = ({control, field, prefix, error, helperText}) => (
  <>
    <FieldLabel required={field.required}>{field.label}</FieldLabel>
    <Controller
      name={buildFieldName(field, prefix)}
      control={control}
      render={({field: rhfField}) => (
        <NumberField
          {...rhfField}
          error={error}
          helperText={helperText}
          placeholder={field.placeholder}
          endAdornment={field.end ? <BrandedInputAdornment position="end">{field.end}</BrandedInputAdornment> : undefined}
        />
      )}
    />
  </>
);

NumberFieldRenderer.propTypes = {
  control: controlPropType.isRequired,
  field: fieldPropType.isRequired,
  prefix: string,
  error: string,
  helperText: string
};

export default NumberFieldRenderer;
